import { Grid } from "@geist-ui/core";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import {
  EnvelopeFill,
  Facebook,
  Linkedin,
  Messenger,
  Pinterest,
  Twitter,
  Whatsapp,
} from "react-bootstrap-icons";
import Helmet from "react-helmet";
import { useSearchParams } from "react-router-dom";
import {
  EmailShareButton,
  FacebookMessengerShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";
import NavHeader from "../../Components/NavHeader";
import {
  HEA_OPTIONS,
  HE_OPTIONS,
  HHS_OPTIONS,
  HR_NATURE_OPTIONS,
  HU_EE_OPTIONS,
  HU_HC_OPTIONS,
  HU_HR_OPTIONS,
  HY_OPTIONS,
} from "../../Utils/Options";
import "./styles.css";

const message = "These are my top three youB Environmental and Social Values! Feel free to try it out for yourself- what are your top values?";

function Results() {
  let [searchParams, setSearchParams] = useSearchParams();
  const [name, setName] = useState("");
  const [values, setValues] = useState([]);
  const [url, setUrl] = useState(null);

  //console.log(searchParams, "same thing");

  useEffect(() => {
    const urlName = searchParams.get("name");
    const urlValues = searchParams.get("values");

    var valuesArray = urlValues.split(",");

    const newUrl = new URL(
      `https://youb-esr-app.web.app/esr/results/?${searchParams}`
    );

    //console.log(newUrl.href, "trash");

    setName(urlName);
    setValues(valuesArray);
    setUrl(newUrl.href);

    return null;
  }, [searchParams]);

  const renderTopValues = () => {
    const mergedArray = _.concat(
      HE_OPTIONS,
      HR_NATURE_OPTIONS,
      HHS_OPTIONS,
      HEA_OPTIONS,
      HY_OPTIONS,
      HU_EE_OPTIONS,
      HU_HR_OPTIONS,
      HU_HC_OPTIONS
    );

    return values.map((item, index) => {
      const obj = mergedArray.find((o) => o.value === item);
      console.log(obj, item, "cans");
      if (obj.link) {
        return (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={obj.link}
            key={index}
            className="valueString"
          >
            {item}
          </a>
        );
      } else {
        return (
          <p key={index} className="valueString">
            {item}
          </p>
        );
      }
    });
  };

  const renderShareContainer = () => {
    return (
      <div className="shareContainer">
        <FacebookShareButton
          url={url}
          resetButtonStyle
          className={"shareButton"}
          quote={message}
        >
          <Facebook size={35} color={"rgb(31,31,31)"} />
        </FacebookShareButton>
        {/* <PinterestShareButton url={url} description={message}>
          <Pinterest size={35} color={"rgb(31,31,31)"} />
        </PinterestShareButton> */}
        <FacebookMessengerShareButton url={url}>
          <Messenger size={35} color={"rgb(31,31,31)"} />
        </FacebookMessengerShareButton>
        <TwitterShareButton url={url} title={message}>
          <Twitter size={35} color={"rgb(31,31,31)"} />
        </TwitterShareButton>
        <LinkedinShareButton url={url} title={'youB Top Values'} summary={message}>
          <Linkedin size={35} color={"rgb(31,31,31)"} />
        </LinkedinShareButton>
        <WhatsappShareButton url={url} title={message}>
          <Whatsapp size={35} color={"rgb(31,31,31)"} />
        </WhatsappShareButton>
        <EmailShareButton url={url} body={message} subject={'youB Top Values'} separator={`\n\n`}>
          <EnvelopeFill size={35} color={"rgb(31,31,31)"} />
        </EmailShareButton>
      </div>
    );
  };

  const renderGrid = () => {
    return (
      <Grid.Container>
        <Grid xs={24} sm={9}>
          <div className="left">
            <img
              src="https://images.unsplash.com/photo-1518495973542-4542c06a5843?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2787&q=80"
              alt="youB Trees"
            />
          </div>
        </Grid>
        <Grid xs={24} sm={15}>
          <div className="right">
            <div className="resultsSection">
              <div className="header">
                <h1>
                  <strong>{name}</strong>, your top values are:
                </h1>
                <div className="topValuesContainer">{renderTopValues()}</div>
              </div>
              <p className="body">
                Well done. These youB Values are at the heart of your search to
                be the energy behind what matters. Now you can explore youB for
                information, inspiration, and motivation around the Values that
                speak to you. Join our youB community, find like-minded people,
                submit creative content, and find many ways to make a difference
                locally and globally. 
              </p>
              <a target="_blank"
            rel="noopener noreferrer" href="https://www.youb.com/" >Learn more at youb.com </a>
            </div>
            <div className="resultsSection">
              <h3>Key questions to ponder:</h3>
              <p className="keyQuestion">
                How do we support these values for ourselves—at home, at work,
                out in the world?
              </p>
              <p className="keyQuestion">
                How do we support these values for others?
              </p>
              <p className="keyQuestion">
                Where are we strong? Where can we do better?
              </p>
            </div>
            <div className="resultsSection">
              <h3>Share your results:</h3>
              {renderShareContainer()}
            </div>
          </div>
        </Grid>
      </Grid.Container>
    );
  };

  //console.log(name, values, "open source");
  return (
    <div id={"results"}>
      <Helmet>
        <title> {name ? `${name}'s` : ""} Self Reflection Results</title>
        <meta
          property="og:image"
          content="https://firebasestorage.googleapis.com/v0/b/youb-esr-app.appspot.com/o/home-images%2F1.png?alt=media&token=7cadf750-85df-48cf-8958-6f75345c8488"
        />
      </Helmet>
      <NavHeader />
      <div className="resultsContainer">{renderGrid()}</div>
    </div>
  );
}

export default Results;
